import React, { useEffect } from "react";
import dayjs from "dayjs";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Paper,
  Typography,
  IconButton,
  Collapse,
  TextField,
} from "@material-ui/core";
import {
  AddRounded,
  ExpandMoreRounded,
  LinkRounded,
  RemoveRounded,
  SaveRounded,
  Settings,
} from "@material-ui/icons";
import { useDispatch } from "react-redux";
import {
  deleteAfterSchoolInfo,
  editAfterSchoolInfo,
  addAfterSchoolInfo,
} from "../../../redux/actions/adminActions";

export default function AdminAfterSchoolSetting({
  infoOpen,
  setInfoOpen,
  afterSchoolInfo,
}) {
  const dispatch = useDispatch();

  const [settingInfo, setSettingInfo] = React.useState([]);

  useEffect(() => {
    if (afterSchoolInfo) {
      setSettingInfo(afterSchoolInfo);
    }
  }, [afterSchoolInfo]);

  const handleClose = () => {
    setInfoOpen(false);
  };

  return (
    <Dialog
      open={infoOpen}
      fullWidth
      maxWidth="sm"
      onClose={handleClose}
      scroll="paper"
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gridGap={10}>
          <Settings />
          <Typography variant="body1" style={{ fontWeight: "500" }}>
            자격증 과정 정보 관리
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent style={{ minHeight: "500px" }}>
        <Box m={1}>
          {settingInfo.map((item, index) => (
            <Block
              key={item.title}
              {...{
                item,
                index,
                settingInfo,
                setSettingInfo,
                dispatch,
                deleteAfterSchoolInfo,
                editAfterSchoolInfo,
                addAfterSchoolInfo,
              }}
            />
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function Block({
  item,
  index,
  settingInfo,
  setSettingInfo,
  dispatch,
  deleteAfterSchoolInfo,
  editAfterSchoolInfo,
  addAfterSchoolInfo,
}) {
  const [expand, setExpand] = React.useState(false);
  const expandButtonStyle = {
    transform: expand ? "rotate(180deg)" : "rotate(0deg)",
    marginLeft: "auto",
    transition: "transform 500ms ease-in-out",
  };
  const handleAddLine = () => {
    const newLine = {
      title: "입력",
      startDay: "",
      endDay: "",
      desc: "",
      testUrl: "",
    };
    setSettingInfo((prev) => [...prev, newLine]);
  };
  const handleDeleteLine = (id, index) => {
    if (id === undefined) {
      setSettingInfo((prev) => {
        let newSettingInfo = [...prev];
        newSettingInfo.splice(index, 1);
        return newSettingInfo;
      });
    } else {
      const conf = window.confirm("정말 삭제하시겠습니까?");
      if (conf) {
        dispatch(deleteAfterSchoolInfo(id));
        setSettingInfo((prev) => {
          let newSettingInfo = [...prev];
          newSettingInfo.splice(index, 1);
          return newSettingInfo;
        });
      }
    }
  };
  const handleSave = (item) => {
    // Save logic here
    if (
      item.title === "" ||
      item.startDay === "" ||
      item.startDay === "Invalid Date" ||
      item.endDay === "" ||
      item.endDay === "Invalid Date" ||
      item.phone === ""
    ) {
      alert("필수정보를 입력하시기 바랍니다.");
    } else if (dayjs(item.startDay) > dayjs(item.endDay)) {
      alert("종료일은 시작일보다 이후 날짜여야 합니다.");
    } else {
      if (item?.afterschoolVideoId) {
        const conf = window.confirm("수정하시겠습니까?");
        if (conf) {
          dispatch(editAfterSchoolInfo(item));
        }
      } else {
        const conf = window.confirm("추가하시겠습니까?");
        const args = {
          title: item.title,
          type: "certificate",
          startDay: item.startDay,
          endDay: item.endDay,
          desc: item.desc,
          testUrl: item?.testUrl,
        };
        if (conf) {
          dispatch(addAfterSchoolInfo(args));
        }
      }
    }
  };

  return (
    <Paper elevation={1} style={{ marginBottom: 10 }}>
      <Box
        p={1}
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          gridGap={"10px"}
        >
          <IconButton
            size="small"
            onClick={() => setExpand(!expand)}
            style={expandButtonStyle}
            aria-expanded={expand}
            aria-label="show more"
          >
            <ExpandMoreRounded />
          </IconButton>
          <Box onClick={() => setExpand(!expand)} style={{ cursor: "pointer" }}>
            <Typography
              variant="body2"
              style={{
                fontWeight: "500",
                color: item.title === "입력" ? "red" : "black",
              }}
            >
              {item.title}
            </Typography>
          </Box>
        </Box>

        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          gridGap={"10px"}
        >
          <IconButton
            size="small"
            onClick={() => handleDeleteLine(item?.afterschoolVideoId, index)}
          >
            <RemoveRounded color={"primary"} />
          </IconButton>
          <IconButton size="small" onClick={handleAddLine}>
            <AddRounded color="primary" />
          </IconButton>
        </Box>
      </Box>
      {/* collapse */}
      <Collapse in={expand} timeout="auto" unmountOnExit>
        {/* 정보 수정 */}
        <EditInfoLines item={item} handleSave={handleSave} />
      </Collapse>
    </Paper>
  );
}

function EditInfoLines({ item, handleSave }) {
  const [state, setState] = React.useState({
    title: item.title,
    startDay: item.startDay,
    endDay: item.endDay,
    desc: item.desc,
    testUrl: item?.testUrl,
    createdAt: item.createdAt,
    afterschoolVideoId: item?.afterschoolVideoId || "",
  });
  return (
    <Box
      style={{ padding: 10, backgroundColor: "#FAF3E7" }}
      display={"flex"}
      flexDirection={"column"}
      gridGap={"10px"}
      position={"relative"}
    >
      <TextField
        variant="outlined"
        label="타이틀"
        size="small"
        margin="dense"
        value={state.title}
        onChange={(e) => setState({ ...state, title: e.target.value })}
        style={{ width: 350, backgroundColor: "white" }}
      />
      <TextField
        variant="outlined"
        label="시작일"
        size="small"
        margin="dense"
        type="date"
        value={state.startDay}
        onChange={(e) => setState({ ...state, startDay: e.target.value })}
        style={{ width: 350, backgroundColor: "white" }}
      />
      <TextField
        variant="outlined"
        label="종료일"
        size="small"
        margin="dense"
        type="date"
        value={state.endDay}
        onChange={(e) => setState({ ...state, endDay: e.target.value })}
        style={{ width: 350, backgroundColor: "white" }}
      />
      <Typography
        variant="caption"
        style={{ color: "gray", marginTop: "-15px", marginBottom: 5 }}
      >
        *실제 적용 날짜는, 수강생 추가 버튼을 통해 변경할 수 있습니다.
      </Typography>
      <Box display="flex" flexDirection="row" alignItems="center">
        <TextField
          variant="outlined"
          label="test url"
          size="small"
          margin="dense"
          value={state?.testUrl}
          onChange={(e) => setState({ ...state, testUrl: e.target.value })}
          style={{ width: 350, backgroundColor: "white" }}
        />
        {state?.testUrl && (
          <IconButton
            onClick={() => {
              window.open(state?.testUrl, "_blank");
            }}
          >
            <LinkRounded color="primary" />
          </IconButton>
        )}
      </Box>
      <Typography
        variant="caption"
        style={{ color: "gray", marginTop: "-15px" }}
      >
        *영상 시청 완료후에 TEST할 구글 FORM 링크를 생성해서 게시하고, 공유
        주소를 입력하면 됩니다.
      </Typography>
      <TextField
        variant="outlined"
        label="상세설명"
        size="small"
        margin="dense"
        multiline
        minRows={2}
        maxRows={4}
        value={state.desc}
        onChange={(e) => setState({ ...state, desc: e.target.value })}
        style={{ width: 350, backgroundColor: "white" }}
      />
      {state?.afterschoolVideoId && (
        <TextField
          variant="outlined"
          label="id"
          size="small"
          margin="dense"
          defaultValue={state.afterschoolVideoId}
          InputProps={{
            readOnly: true,
          }}
          disabled
          style={{ width: 350, backgroundColor: "white" }}
        />
      )}
      {state?.createdAt && (
        <TextField
          variant="outlined"
          label="생성일자"
          size="small"
          margin="dense"
          defaultValue={dayjs(state.createdAt * 1000).format(
            "YYYY-MM-DD HH:mm:ss"
          )}
          InputProps={{
            readOnly: true,
          }}
          disabled
          style={{ width: 350, backgroundColor: "white" }}
        />
      )}

      <Box style={{ position: "absolute", right: 10, top: 10 }}>
        <IconButton size="small" onClick={() => handleSave(state)}>
          <SaveRounded color="primary" />
        </IconButton>
      </Box>
    </Box>
  );
}
